import { render, staticRenderFns } from "./AppFooterDisclaimer.vue?vue&type=template&id=2071f732&scoped=true&"
import script from "./AppFooterDisclaimer.ts?vue&type=script&lang=ts&"
export * from "./AppFooterDisclaimer.ts?vue&type=script&lang=ts&"
import style0 from "./AppFooterDisclaimer.scss?vue&type=style&index=0&id=2071f732&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2071f732",
  null
  
)

export default component.exports